import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { cn } from '../lib/cn.js';
/**
 * Label + control + hint + error, wired together correctly.
 *
 * Every form in this product goes through this component. Getting the
 * `id` / `htmlFor` / `aria-describedby` / `aria-invalid` relationships right
 * once here is far more reliable than asking each feature to remember them, and
 * it means an error message is announced rather than merely displayed.
 *
 * The render-prop shape keeps it agnostic of the control: the same wrapper
 * serves an `<Input>`, a `<select>`, or a future currency widget.
 */
export function Field({ label, hint, error, required = false, className, children }) {
    const baseId = useId();
    const inputId = `${baseId}-control`;
    const hintId = `${baseId}-hint`;
    const errorId = `${baseId}-error`;
    const describedBy = [hint === undefined ? null : hintId, error === undefined ? null : errorId]
        .filter((value) => value !== null)
        .join(' ');
    return (_jsxs("div", { className: cn('flex flex-col gap-1.5', className), children: [_jsxs("label", { htmlFor: inputId, className: "text-sm font-medium text-content", children: [label, required ? (_jsx("span", { className: "ml-1 text-danger", "aria-hidden": "true", children: "*" })) : null] }), children({
                inputProps: {
                    id: inputId,
                    'aria-describedby': describedBy === '' ? undefined : describedBy,
                    'aria-invalid': error === undefined ? undefined : true,
                    'aria-required': required ? true : undefined,
                },
            }), hint === undefined ? null : (_jsx("p", { id: hintId, className: "text-xs text-content-muted", children: hint })), error === undefined ? null : (
            // `role="alert"` so the message is announced the moment it appears.
            _jsx("p", { id: errorId, role: "alert", className: "text-xs font-medium text-danger", children: error }))] }));
}
//# sourceMappingURL=field.js.map